import posthog from "posthog-js";
import Cookies from "js-cookie";

const analyticsConsent = Cookies.get("analyticsConsent");
const hasGrantedAnalytics = analyticsConsent === "true";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
    api_host: "/webdata",
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
    capture_exceptions: true,
    persistence: hasGrantedAnalytics ? "localStorage+cookie" : "memory",
    person_profiles: "identified_only",
    disable_session_recording: !hasGrantedAnalytics,
});
